import React, { PureComponent } from "react";

class LDiamond extends PureComponent {
    render() {
        return (
            <>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5515 12.9099C13.7174 12.897 15.8833 12.884 18.0492 12.8711L20.9874 15.8654L14.727 21.5951L8.42773 15.9042L11.5472 12.9099H11.5515Z" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M15.4727 13.0508L17.7249 16.0106L14.709 21.3131" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M12.6447 14.5547L11.6523 15.8059L13.6025 17.6051" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M14.2861 11.3839L12.625 8.14362V3.40625" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M8.78629 3.40625V7.99693L4.08775 17.6011C4.08775 17.6011 3.53549 19.3442 5.44683 19.3442H10.4042" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M9.04391 13.5H6.14453" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                    <path d="M7.625 3.40625H13.6697" stroke="#1E1E1E" strokeWidth="0.6" strokeMiterlimit="10" />
                </svg>
            </>
        );
    }
}

export default LDiamond;